import { store } from "../../store";
import { TemplateUIObject, UIKeys } from "@services/storage/storeTemplate";
import * as reducer from "./slice";

export const dispatchHydrateUI = (state: TemplateUIObject) => {
  store.dispatch(
    reducer.hydrate({
      value: state,
    })
  );
};

export const dispatchSetUI = (name: UIKeys, payload: any) => {
  store.dispatch(
    reducer.set({
      name,
      value: payload,
    })
  );
};

export const dispatchResetUI = (payload?: Array<string>) => {
  store.dispatch(
    reducer.reset({
      value: payload,
    })
  );
};

export const dispatchResetUIWithCache = (payload?: Array<string>) => {
  store.dispatch(
    reducer.resetWithCache({
      value: payload,
    })
  );
};

export const dispatchSaveUI = () => {
  store.dispatch(reducer.save());
};

export const dispatchUILoading = () => {
  store.dispatch(reducer.loading());
};

export const dispatchUILoaded = () => {
  store.dispatch(reducer.loaded());
};

export const dispatchResetSquareUI = () => {
  store.dispatch(reducer.resetSquare());
};

export const dispatchSetMultipleUI = (payload: Partial<TemplateUIObject>) => {
  store.dispatch(
    reducer.setMultiple({
      value: payload,
    })
  );
};

export const dispatchSetSnackMsg = (payload: Partial<TemplateUIObject>) => {
  store.dispatch(
    reducer.setSnackMsg({
      value: payload,
    })
  );
};

export const dispatchSetSnackMsgError = (payload: Partial<TemplateUIObject>) => {
  store.dispatch(
    reducer.setSnackMsg({
      value: { ProblemMsg: payload.ProblemMsg, ProblemMsgVariant: "error", ProblemShowMsg: true },
    })
  );
};
export const dispatchSetSnackMsgSuccess = (payload: Partial<TemplateUIObject>) => {
  store.dispatch(
    reducer.setSnackMsg({
      value: { ProblemMsg: payload.ProblemMsg, ProblemMsgVariant: "success", ProblemShowMsg: true },
    })
  );
};
export const dispatchSetSnackMsgWarn = (payload: Partial<TemplateUIObject>) => {
  store.dispatch(
    reducer.setSnackMsg({
      value: { ProblemMsg: payload.ProblemMsg, ProblemMsgVariant: "warning", ProblemShowMsg: true },
    })
  );
};
export const dispatchSetSnackMsgInfo = (payload: Partial<TemplateUIObject>) => {
  store.dispatch(
    reducer.setSnackMsg({
      value: { ProblemMsg: payload.ProblemMsg, ProblemMsgVariant: "info", ProblemShowMsg: true },
    })
  );
};

export default reducer;
